export default {
  inject: ['load'],
  data() {
    return {
      allHeadacheOtherSignsForOther: [],
      headacheOtherSign: null,
    };
  },
  methods: {
    getListOfHeadacheOtherSignsForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllHeadacheOtherSigns').then(() => {
        if (this.$store.state.headacheOtherSignModule.successFlag) {
          this.allHeadacheOtherSignsForOther =
            this.$store.state.headacheOtherSignModule.allHeadacheOtherSigns;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.headacheOtherSignModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfHeadacheOtherSignsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getHeadacheOtherSignFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getHeadacheOtherSign', id).then(() => {
        if (this.$store.state.headacheOtherSignModule.successFlag) {
          this.headacheOtherSign = this.$store.state.headacheOtherSignModule.headacheOtherSign;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.headacheOtherSignModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getHeadacheOtherSignFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.headacheOtherSignModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
